/** LocalStorage values default TTL (in seconds) **/
export const LS_TTL = 60 * 60 * 24;

export const CONSOLE_PREFIX = "[Entity viewer]";
export const SPOILER_MIN_LENGTH = 500;
